
        import Ext_0 from './app/render/integrations/pipeorders/pipeorders'
import Ext_1 from './app/render/integrations/klaviyo/klaviyo'
import Ext_2 from './app/render/integrations/pagePreload/pagePreload'
import Ext_3 from './app/render/integrations/cdp/cdp'
import Ext_4 from './app/render/integrations/gtm/gtm'
import Ext_5 from './app/render/integrations/fitnessfunctions/fitnessfunctions'
import Ext_6 from './app/render/integrations/trackingProperties/trackingProperties'
import Ext_7 from './app/render/integrations/segment/segment'
import Ext_8 from './app/render/integrations/bugsnag/bugsnag'
import Ext_9 from './app/render/integrations/checkout/checkout'
import Ext_10 from './app/render/integrations/buildSettings/buildSettings'
import Ext_11 from './app/render/integrations/fraudNet/fraudNet'
import Ext_12 from './app/render/integrations/yuno/yuno'
        export default [{
          type: 'PIPEORDERS',
          key: 'global.pipeorders',
          singleton: true,
          headClientOnly: false,
          config: {"apiHost":"https://api-pipeorders.in.nutrameg.com"},
          module: Ext_0
        },
{
          type: 'KLAVIYO',
          key: 'brand.pbmEn',
          singleton: true,
          headClientOnly: true,
          config: {"publicKey":"VXgWJh"},
          module: Ext_1
        },
{
          type: 'PAGE_PRELOAD',
          key: 'brand.preloadBM',
          singleton: true,
          headClientOnly: false,
          config: {},
          module: Ext_2
        },
{
          type: 'CDP',
          key: 'brand.cdpPilates',
          singleton: true,
          headClientOnly: false,
          config: {"writeKey":"J4Fy8IM24_w9Oxkv1qf9nyGI9bNcd5gjv9bL7qeBKyQ","host":"https://events.cdp.in.nutrameg.com"},
          module: Ext_3
        },
{
          type: 'GTM',
          key: 'brand.pilatesBM',
          singleton: true,
          headClientOnly: true,
          config: {"containerId":"GTM-TV6HV98D","cookieConsentEnabled":false,"pipeConfigsDataLayer":{"tiktokIntegration":{"isEnabled":false}}},
          module: Ext_4
        },
{
          type: 'FITNESS_FUNCTIONS',
          key: 'global.fitnessFunctions',
          singleton: true,
          headClientOnly: false,
          config: {},
          module: Ext_5
        },
{
          type: 'TRACKING_PROPERTIES',
          key: 'global.trackingProperties',
          singleton: true,
          headClientOnly: false,
          config: {},
          module: Ext_6
        },
{
          type: 'SEGMENT',
          key: 'global.segmentGlobalWriteKey',
          singleton: true,
          headClientOnly: true,
          config: {"writeKey":"1xyxAgckLKpBgGGy1PN60gqEWoAjr8hQ","delivery":"shadow","cdpWriteKey":"KIF7DEUrRi8URAqjzy_VG23NX5YF0KCfZoM6tx22JWc","cdpHost":"https://events.cdp.in.nutrameg.com"},
          module: Ext_7
        },
{
          type: 'BUGSNAG',
          key: 'global.bugsnag',
          singleton: true,
          headClientOnly: false,
          config: {"apiKey":"78b6ac6437fe8257e92c9ffc81995655","releaseStage":"production","appVersion":"0.0.1","enabledReleaseStages":"production"},
          module: Ext_8
        },
{
          type: 'CHECKOUT',
          key: 'global.checkoutSDK',
          singleton: true,
          headClientOnly: false,
          config: {},
          module: Ext_9
        },
{
          type: 'BUILD_SETTINGS',
          key: 'global.oldBrowserSupport',
          singleton: true,
          headClientOnly: false,
          config: {"legacyBrowsers":true},
          module: Ext_10
        },
{
          type: 'FRAUDNET',
          key: 'global.fraudNet',
          singleton: true,
          headClientOnly: false,
          config: {},
          module: Ext_11
        },
{
          type: 'YUNO',
          key: 'YUNO',
          singleton: true,
          headClientOnly: false,
          config: {},
          module: Ext_12
        }]
      